<template>
  <div class="fixed top-0 z-49 text-white text-center w-full pointer-events-none">
    <div
      v-if="showDevPanel"
      class="text-white z-50 rounded-b-lg mx-auto p-5 pt-0.5 pointer-events-auto flex flex-col gap-2 items-center sm:w-4/12 w-full"
      :class="{
        'bg-green-400': isLocal,
        'bg-blue-400': isDev,
        'bg-orange-400': isTest,
        'bg-red-400': isStaging
      }"
      @click="showDevPanel = false"
    >
      <div class="text-xl uppercase">
        {{ config.environment }}
      </div>
      <template v-if="isLocal">
        <div class="w-full flex justify-between">
          <div>Screen:</div>
          <div class="3xs:hidden">&lt;3XS</div>
          <div class="hidden 3xs:block 2xs:hidden">3XS</div>
          <div class="hidden 2xs:block xs:hidden">2XS</div>
          <div class="hidden xs:block sm:hidden">XS</div>
          <div class="hidden sm:block md:hidden">SM</div>
          <div class="hidden md:block lg:hidden">MD</div>
          <div class="hidden lg:block xl:hidden">LG</div>
          <div class="hidden xl:block">XL</div>
        </div>
        <div class="w-full flex justify-between">
          <div>Installation Type:</div>
          <div v-if="authStore.isPortal">Portal</div>
          <div v-else>Business</div>
        </div>
        <div class="w-full flex justify-between">
          <div>Token Type:</div>
          <div v-if="authStore.loggedIn === false">Unauthenticated</div>
          <div v-else-if="authStore.isPortalUser && !authStore.isBrandedModeUser">Portal</div>
          <div v-else-if="authStore.isBusinessUser">Business</div>
          <div v-else-if="authStore.isBrandedModeUser">Lead Capture</div>
        </div>
        <div class="w-full flex justify-between">
          <div>Server URL:</div>
          <div>{{ server_url }}</div>
        </div>
      </template>
      <template v-if="isLocal || authStore.superuser">
        <div v-if="branch" class="w-full flex justify-between">
          <div>Branch:</div>
          <CopyToClipboard :input="branch" @click.stop>
            {{ branch }}
          </CopyToClipboard>
        </div>
        <div v-if="commit" class="w-full flex justify-between group">
          <div>Commit:</div>
          <CopyToClipboard :input="commit" @click.stop>
            {{ commit }}
          </CopyToClipboard>
        </div>
      </template>
    </div>
    <div
      v-else
      class="px-5 py-0.5 inline-block rounded-b-lg cursor-pointer pointer-events-none"
      :class="{
        'bg-green-400': isLocal,
        'bg-blue-400': isDev,
        'bg-orange-400': isTest,
        'bg-red-400': isStaging,
        '!pointer-events-auto': authStore.superuser || isLocal
      }"
      @click="showDevPanel = true"
    >
      <span class="text-xl uppercase">{{ config.environment }}</span>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/pinia/auth'
import { config } from '@/utils/config'
import { mapStores } from 'pinia'
import CopyToClipboard from '@/components/shared/ui/CopyToClipboard.vue'

export default {
  components: {
    CopyToClipboard
  },
  name: 'DebugBanner',

  data() {
    return {
      showDevPanel: false
    }
  },
  setup() {
    return { config }
  },
  computed: {
    ...mapStores(useAuthStore),
    server_url() {
      return this.isLocal ? `${config.base_url}/api` : config.api_url
    },
    branch() {
      return import.meta.env.VITE_APP_GIT_BRANCH
    },
    commit() {
      return import.meta.env.VITE_APP_GIT_COMMIT
    },
    isLocal() {
      return config.environment.includes('local')
    },
    isDev() {
      return config.environment.includes('dev')
    },
    isTest() {
      return config.environment.includes('test')
    },
    isStaging() {
      return config.environment.includes('staging')
    }
  }
}
</script>

<style scoped></style>
